/**
 * Created by Ning Jiang on 10/1/2018.
 */

import {IInitData, IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {WinterHoardServerDataParser} from "../WinterHoardServerDataParser";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StateMatrix} from "../../utils/StateMatrix";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {ISpinGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/ISpinServerData";
import {WinterHoardGameMode} from "../../gamemode/WinterHoardGameMode";

export interface IWinterHoardServerData extends IServerData {
    numberFreespins: number[];
    // TODO
}

export interface IWinterHoardInitData extends IInitData, IWinterHoardServerData {
    // TODO
    evaluatedReels:string[][];
    scattersPositions:number[];
    scattersCollected:number[];
    energyCollectedBefore:number;
    energyCollectedAfter:number;
    freespinsPlayed:number;
    symbolsToM1:string [];
    overlayM1: string [][];
    energyCollected:number;

    energyCollectPositions: boolean [][];
    symbolMultipliers: any;


    addFreespins:number;
}

export interface IWinterHoardGameData extends ISpinGameData, IWinterHoardServerData {
    mysterySymbolAppearing:string;
    mysterySymbolRevealed:string;
    shamanspinTriggered:boolean;
    evaluatedReels:string[][];
    scattersPositions:number[];
    scattersCollected:number[];
    energyCollectedBefore:number;
    energyCollectedAfter:number;
    freespinsPlayed:number;
    symbolsToM1:string [];
    overlayM1: boolean [][];

    energyCollectPositions: boolean [][];
    symbolMultipliers: any;

    addFreespins:number;
}


export class WinterHoardParsedInitData extends ParsedInitData {
    public numberFreespins: number[];
    public evaluatedReels:string[][];
    public energyCollectedBefore:number;
    public energyCollectedAfter:number;
    public energyCollected:number;
    public symbolsToM1:string [];
    public energyCollectPositions: boolean [][];
    public overlayM1: string [][];
    public freespinsPlayed: number;
    public addFreespins:number;

    private readonly _accumulatedRoundWin:string;
    public get accumulatedRoundWin():string {
        return this._accumulatedRoundWin;
    }

    public symbolMultipliers:{M1:number, M2:number, M3:number, M4:number, M5:number};

    constructor(rawData:IWinterHoardInitData, dataParser:WinterHoardServerDataParser) {
        super(rawData, dataParser);
        this.numberFreespins = rawData.numberFreespins;

        this.energyCollectedBefore = rawData.energyCollectedBefore;
        this.energyCollectedAfter = rawData.energyCollectedAfter;
        this.energyCollected = rawData.energyCollected;

        this.symbolsToM1 = rawData.symbolsToM1 || [];
        this.energyCollectPositions = [[false, false, false, false], [false, false, false, false], [false, false, false, false], [false, false, false, false], [false, false, false, false]];

        this.symbolMultipliers = rawData.symbolMultipliers;

        // TODO: overlayM1, these are the transformed lower M symbols, they need to be subtracted from the energy collect
        this.overlayM1 = rawData.overlayM1;

        this.addFreespins = this.addedNumberOfFreespinsThisSpin || 0;


        if(this.energyCollectedAfter > 0) {

            // Subtract overlay wild positions, these doesn't hold energy;
            this.evaluatedReels.forEach((reelVal, reelId:number) => {
                reelVal.forEach((symVal, symId:number) => {
                    if(symVal === "M1"  && !this.overlayM1[reelId][symId]) {
                        this.energyCollectPositions[reelId][symId] = true;
                    }
                });
            });
        }

        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    get isTotalWin(): boolean {
        return (this.mode.includes("FREESPIN") || this.nextMode.includes("FREESPIN"));
    }
}

export class WinterHoardParsedGameData extends SpinParsedGameData {
    public scattersCollected:number[];
    public evaluatedReels:string[][];
    public scattersPositions:number[];
    public shamanspinTriggered:boolean;
    public mysterySymbolRevealed:string;
    public mysterySymbolAppearing:string;
    public mysterySymbolPositions:[number, number][];
    public mysteryReels:boolean[];
    public energyCollectedBefore:number;
    public energyCollectedAfter:number;
    public symbolsToM1:string [];
    public energyCollectPositions: boolean [][];
    public overlayM1: boolean [][];
    public numberFreespins: number[];
    public freespinsPlayed: number;
    public addFreespins:number;
    public totalSpinWinnings:number;

    private readonly _accumulatedRoundWin:string;
    public get accumulatedRoundWin():string {
        return this._accumulatedRoundWin;
    }

    public symbolMultipliers:{M1:number, M2:number, M3:number, M4:number, M5:number};

    constructor(rawData:IWinterHoardGameData, dataParser:WinterHoardServerDataParser) {
        super(rawData, dataParser);
        this.evaluatedReels = rawData.evaluatedReels;
        this.scattersPositions = rawData.scattersPositions;
        this.scattersCollected = rawData.scattersCollected;

        this.shamanspinTriggered = rawData.shamanspinTriggered;
        this.mysterySymbolRevealed = rawData.mysterySymbolRevealed;
        this.mysterySymbolAppearing = rawData.mysterySymbolAppearing;
        this.numberFreespins = rawData.numberFreespins;
        this.freespinsPlayed = rawData.freespinsPlayed;

        this.mysterySymbolPositions = [];
        this.mysteryReels = [false,false,false,false,false];

        this.energyCollectedBefore = rawData.energyCollectedBefore;
        this.energyCollectedAfter = rawData.energyCollectedAfter;

        this.symbolsToM1 = rawData.symbolsToM1 || [];
        this.energyCollectPositions = [[false, false, false, false], [false, false, false, false], [false, false, false, false], [false, false, false, false], [false, false, false, false]];

        this.symbolMultipliers = rawData.symbolMultipliers;

        this.addFreespins = this.addedNumberOfFreespinsThisSpin || 0;

        this.totalSpinWinnings = Number.parseFloat(rawData.totalSpinWinnings);

        // TODO: overlayM1, these are the transformed lower M symbols, they need to be subtracted from the energy collect
        this.overlayM1 = rawData.overlayM1;

        if(this.energyCollectedAfter > 0) {

            // Subtract overlay wild positions, these doesn't hold energy;

            this.evaluatedReels.forEach((reelVal, reelId:number) => {
                reelVal.forEach((symVal, symId:number) => {
                    if(symVal === "M1"  && !this.overlayM1[reelId][symId]) {
                        this.energyCollectPositions[reelId][symId] = true;
                    }
                });
            });
        }


        if(this.mysterySymbolAppearing || this.shamanspinTriggered) {
            //this.reels;
            //debugger;
            this.findMysterySymbols();

            if(this.mysterySymbolAppearing) {
                this.replaceSymbolsInReels(this.mysterySymbolPositions, "M");

            }

            if(this.shamanspinTriggered) {
                this.replaceSymbolsInReels(this.mysterySymbolPositions, "M");
            }
        }

        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    get isTotalWin(): boolean {
        return (this.mode === WinterHoardGameMode.FREESPIN_MULTIPLIER || this.mode === WinterHoardGameMode.FREESPIN_TRANSFORM || this.mode === WinterHoardGameMode.FREESPIN_COMBINED);
    }

    private findMysterySymbols() {
        const reelMatrix = new StateMatrix<string>(
            GameConfig.instance.REELS_NUM,
            GameConfig.instance.SYMBOLS_NUM_IN_REEL[1] + GameConfig.instance.SYMBOLS_NUM_IN_REEL[2] + GameConfig.instance.SYMBOLS_NUM_IN_REEL[3],
            [GameConfig.instance.SYMBOLS_NUM_IN_REEL[1], GameConfig.instance.SYMBOLS_NUM_IN_REEL[1] + GameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1],
            ""
        );
        reelMatrix.initAbsolute(this.reels.concat());

        //debugger;
        this.mysterySymbolPositions = reelMatrix.getVisibleCoordinatesWithState("M");

        for (let pos of this.mysterySymbolPositions){
            this.mysteryReels[pos[0]] = true;
        }


    }

    private replaceSymbolsInReels(coords:[number, number][], replacement:string) {
        for(let position of coords) {
            const reelId = position[0];
            const symId = position[1] + GameConfig.instance.SYMBOLS_NUM_IN_REEL[1];
            this.reels[reelId][symId] = replacement;
        }
    }
}